import { render, staticRenderFns } from "./TEST_YZT_SJH_XM.vue?vue&type=template&id=b5f7c382&scoped=true"
import script from "./TEST_YZT_SJH_XM.vue?vue&type=script&lang=js"
export * from "./TEST_YZT_SJH_XM.vue?vue&type=script&lang=js"
import style0 from "./TEST_YZT_SJH_XM.vue?vue&type=style&index=0&id=b5f7c382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f7c382",
  null
  
)

export default component.exports